export default __webpack_public_path__ + "static/content-l7-1-b705e1875bae29ea4922f5af3ccfa76b.png";